import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { toggleRolePermission } from '../actions';
import PermissionRow from '../components/PermissionRow';

const PermissionsTableRows = ({
  category,
  code,
  canEdit,
  disabled,
  updateStatus,
  permissions,
  grouping,
  categories,
  togglePermission,
}) => {
  const rows = [];
  const disable = disabled || !canEdit || updateStatus === states.PENDING;

  categories.forEach((item) => (
    item.actions.forEach((action) => {
      rows.push(
        <PermissionRow
          key={`permission_row_${item.name}_${action.name}`}
          action={action}
          category={item}
          disabled={disable}
          onClick={() => togglePermission(category, code, item.name, action.name)}
          permissions={permissions}
          grouping={grouping}
        />,
      );
    })
  ));

  return rows;
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);

  return (
    {
      canEdit: update && !item.system,
      permissions: item.permissions,
      updateStatus: item.updateStatus,
    }
  );
};

const mapDispatchToProps = {
  togglePermission: toggleRolePermission,
};

export default connect(mapStateToProps, mapDispatchToProps)(PermissionsTableRows);
